// Custom packages
import { Injectable } from "@angular/core";

// Third party packages
import { MatDrawerToggleResult, MatSidenav } from "@angular/material/sidenav";

@Injectable({
  providedIn: "root"
})
export class SidenavService {
  private sidenav: MatSidenav;

  /**
   * Class constructor
   */
  // constructor() {}

  /**
   * Set sidenav object
   *
   * @since 1.0.0
   *
   * @param sidenav Sidenav object
   */
  public setSidenav(sidenav: MatSidenav): void {
    this.sidenav = sidenav;
  }

  /**
   * Open sidenav
   *
   * @since 1.0.0
   *
   * @returns Promise<MatDrawerToggleResult>
   */
  public open(): Promise<MatDrawerToggleResult> {
    return this.sidenav.open();
  }

  /**
   * Close sidenav
   *
   * @since 1.0.0
   *
   * @returns Promise<MatDrawerToggleResult>
   */
  public close(): Promise<MatDrawerToggleResult> {
    return this.sidenav.close();
  }

  /**
   * Toggle sidenav state
   *
   * @since 1.0.0
   *
   * @returns Promise<MatDrawerToggleResult>
   */
  public toggle(): Promise<MatDrawerToggleResult> {
    return this.sidenav.toggle();
  }
}
